interface IModalConfirmationProps {
  fieldName: string;
  textImpact?: string;
  hasPauseActive?: boolean;
}

export default function ModalConfirmation({ fieldName, textImpact, hasPauseActive }: IModalConfirmationProps) {
  return (
    <div className="mr-30">
      {`You are about to modify the ${fieldName} for the Contract Line(s)`}<br />
      {textImpact ?? 'This change could potentially impact Sales Order generation.'}<br />
      {hasPauseActive && (
        <>
          <br />
          <strong>Warning:</strong> This action will change the billing date.
          A Pause to billing is set. Please review your Pause End Date to ensure accurate billing.<br />
        </>
      )}
      Please confirm you wish to continue.
    </div>
  );
}
